import { useUserMetaState } from 'modules/queries/account/user/stateData/useUserMetaState';

const DISMISSAL_SERIES_WEEKS = [2, 4, 8]; // 8 repeats forever after

const getDismissalDurationWeeks = (count: number) => {
	const index = Math.min(count, DISMISSAL_SERIES_WEEKS.length - 1);
	return DISMISSAL_SERIES_WEEKS[index];
};

export const useUserMetaStateProgressiveDismissal = (keyPrefix: string) => {
	const [dismissedCount, setDismissedCount] = useUserMetaState<number>(
		`${keyPrefix}_count`,
		0,
	);
	const [dismissedUntil, setDismissedUntil] = useUserMetaState<number>(
		`${keyPrefix}_until`,
		0,
	);

	const isDismissed = dismissedUntil > Date.now();

	const dismiss = () => {
		const weeks = getDismissalDurationWeeks(dismissedCount);
		const until = Date.now() + weeks * 7 * 24 * 60 * 60 * 1000;
		setDismissedCount(dismissedCount + 1);
		setDismissedUntil(until);
	};

	return { isDismissed, dismiss, dismissedCount, dismissedUntil };
};

export default useUserMetaStateProgressiveDismissal;
